module.exports = __webpack_public_path__ + "img/1_027.3040275f.jpg";